import {
  ServerError,
  InsufficientPermissions
} from 'modals/RepositoriesModalV2/repositories-modal.components';
import * as LighthouseService from 'common/services/lighthouse.service';
import { ARTICLE_IDS } from 'common/constants/constants';
import { findAndDeleteSensor } from 'modals/RepositoriesModalV2/repositories-modal.service';
import Text from 'components/base/Text';
import * as ZendeskService from 'common/services/zendesk.service';
import { LBButton } from '@linearb/buzz';

const RepositoriesModalErrorHandler = ({
  error,
  gitIntegrations,
  sensor_authorization_id,
  deleteSensorAuthorization,
  isOnboarding,
  openReAuthModal
}) => {
  switch (error) {
    case 401:
    case 403:
      return (
        <InsufficientPermissions
          onClick={() =>
            LighthouseService.navigateArticle(
              ARTICLE_IDS.ONBOARDING_TROUBLESHOOT
            )
          }
          findAndDeleteSensor={() =>
            findAndDeleteSensor({
              gitIntegrations,
              sensor_authorization_id,
              deleteSensorAuthorization
            })
          }
          isOnboarding={isOnboarding}
          openReAuthModal={openReAuthModal}
        />
      );
    case 500:
      return (
        <ServerError
          info={
            <Text size='medium' color='shuttleGray'>
              This is probably temporary, try again in a bit, or{' '}
              <LBButton
                variant='ghost'
                onClick={ZendeskService.openSupportRequest}
              >
                contact support
              </LBButton>
            </Text>
          }
        />
      );
    default:
      return <ServerError />;
  }
};

export default RepositoriesModalErrorHandler;
